var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAiStepIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 50,
    height: 31,
    viewBox: "0 0 50 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.47711 6.6439C8.04918 7.21597 8.97662 7.21597 9.54869 6.6439L13.692 2.50063C14.264 1.92856 14.264 1.00112 13.692 0.429053C13.1199 -0.143018 12.1924 -0.143018 11.6204 0.429053L8.51295 3.53647L7.47721 2.50073C6.90514 1.92866 5.9777 1.92866 5.40563 2.50063C4.83356 3.07261 4.83356 4.00015 5.40553 4.57222L7.47711 6.6439ZM36.4186 6.6439C36.9907 7.21597 37.9181 7.21597 38.4902 6.6439L42.6334 2.50063C43.2055 1.92856 43.2055 1.00112 42.6334 0.429053C42.0614 -0.143018 41.1339 -0.143018 40.5619 0.429053L37.4544 3.53647L36.4186 2.50063C35.8465 1.92856 34.9191 1.92856 34.347 2.50063C33.775 3.07261 33.775 4.00015 34.347 4.57222L36.4186 6.6439ZM21.9479 6.6439C22.52 7.21597 23.4474 7.21597 24.0195 6.6439L28.1627 2.50063C28.7346 1.92856 28.7346 1.00112 28.1627 0.429053C27.5906 -0.143018 26.6631 -0.143018 26.0911 0.429053L22.9837 3.53638L21.9479 2.50054C21.3758 1.92847 20.4484 1.92847 19.8763 2.50054C19.3043 3.07251 19.3043 4.00005 19.8763 4.57212L21.9479 6.6439ZM27.3336 11.7188H14.1868L19.4999 20.2198C19.6454 20.4526 19.7225 20.7216 19.7225 20.9961C19.7225 21.2707 19.6454 21.5397 19.4999 21.7725L14.1868 30.2735H27.3336L33.1319 20.9961L27.3336 11.7188Z",
    fill: "url(#paint0_linear_2731_9123)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.7359 11.7188H1.46484C0.655859 11.7188 0 12.3746 0 13.1836V28.8086C0 29.6176 0.655859 30.2734 1.46484 30.2734H10.7359L16.5343 20.9961L10.7359 11.7188ZM49.7773 20.2197L44.8945 12.4072C44.7628 12.1965 44.5798 12.0228 44.3624 11.9024C44.1451 11.7819 43.9008 11.7187 43.6523 11.7188H30.7923L36.1054 20.2197C36.2509 20.4525 36.328 20.7216 36.328 20.9961C36.328 21.2706 36.2509 21.5397 36.1054 21.7725L30.7923 30.2734H43.6523C43.9008 30.2734 44.1451 30.2102 44.3624 30.0898C44.5798 29.9694 44.7628 29.7956 44.8945 29.585L49.7773 21.7725C49.9228 21.5397 50 21.2706 50 20.9961C50 20.7216 49.9228 20.4525 49.7773 20.2197Z",
    fill: "url(#paint1_linear_2731_9123)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2731_9123",
    x1: 3.83398,
    y1: 4.5,
    x2: 35.6487,
    y2: 38.4479,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2C262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82CCF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_2731_9123",
    x1: -1.5,
    y1: 14.4768,
    x2: 12.8515,
    y2: 47.2785,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#19B0F3"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.54,
    stopColor: "#E2C262"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B82CCF"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAiStepIcon);
export default __webpack_public_path__ + "static/media/AIStepIcon.293f1835.svg";
export { ForwardRef as ReactComponent };